<template>
	<div v-if="loading" class="alert" v-bind:class="'alert-'+color">
		<div v-if="icon == 'spinner'" ><i class="fa fa-spinner fa-spin"></i>&nbsp;&nbsp;{{ text }}</div>
		<div v-if="icon == 'error'" ><i class="fa fa-exclamation-triangle"></i>&nbsp;&nbsp;{{ text }}</div>
	</div>
</template>

<script type="text/babel">
export default {
	name: 'loading-alert',
	props: {
 		'loading': {
			default: true,
			type: Boolean	 
		},
		'text': {
			default: "Loading",
			type: String
		},
		'color': {
			default: "warning",
			type: String
		},
		'icon': {
 		    default: "spinner",
			type: String
		}
	}
}
</script>
